import { Layout, Typography, Modal, Button } from "antd";
import React, { useEffect } from "react";
import CustomMenu from "../Components/CustomMenu";
import Navigation from "../Components/Navigation";
import { useState, useRef } from "react";
import { CrownOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const date = "2026-05-26";

const { Header, Content } = Layout;

const TopNavLayout = ({ children, AppStore, props }) => {
  useEffect(() => {}, []);
  const [open, setOpen] = useState(true);

  return (
    <Layout style={{ height: "100vh" }}>
      <Header style={{ padding: 0 }}>
        <Navigation AppStore={AppStore} mode="horizontal" />
      </Header>
      <Layout style={{ flex: 1 }}>
        <CustomMenu AppStore={AppStore} />
        <Content
          style={{
            padding: 24,
            overflowY: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default TopNavLayout;
